
type Feature = {
  title: string;
  description: string;
  image: string;
};

type FeaturesSectionProps = {
  features: Feature[];
};

const SmallScreenFeatures2: React.FC<FeaturesSectionProps> = ({ features }) => (
  <div className="bg-[#F5F7FA] pb-1 pt-[64px] md:pt-[120px] px-6 max-w-[480px] mx-auto">
    <div className="mb-10">
      
      <h2 className="font-utility font-[500] text-[30px] leading-[130%] tracking-[-0.01em] text-[#011621]">Discover the technology, capabilities, and quality systems that power our glass</h2>
    </div>

    {features.map((feature, index) => (
      <div key={index} className="mb-10">
        <h3 className="font-utility font-[500] text-[24px] text-[#011621] mb-4">{feature.title}</h3>
        <div className="w-full mb-4 overflow-hidden ">
          <img
            src={feature.image}
            alt={feature.title}
            className="w-full h-full max-h-[184px]  max-w-[328px] object-cover"
          />
        </div>
        <p className="text-[16px] leading-[150%] text-[#011621] font-normal">{feature.description}</p>
      </div>
    ))}
  </div>
);

export default SmallScreenFeatures2;
